import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDialogComponent } from '../mat-dialog/mat-dialog.component';
import { ActivatedRoute } from '@angular/router';
import {
  Checkpoint,
  Client,
  DealerMediaResponse,
  EndApproval,
  FindingTypeOption,
  GetDetailsResponse,
  ServiceJob,
  StyleSettingsDealerImage,
  StyleSettingsResponse,
  StyleSettingTitles,
} from '../services/client.service';
import * as langConfig from 'src/assets/languageConfig/languageConfig.json';
import { catchError, forkJoin, of, pipe } from 'rxjs';
import { AppService } from '../services/app.service';
import { VideoPlayerService } from '../services/video-player.service';
import { MatCardModule } from '@angular/material/card';
import {
  ButtonModule,
  IconModule,
  StructuredListModule,
  TilesModule,
} from 'carbon-components-angular';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { VideoPlayerComponent } from '../video-player/video-player.component';
import { CarouselComponent } from '../carousel/carousel.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatCardModule,
    TilesModule,
    MatExpansionModule,
    MatIconModule,
    VideoPlayerComponent,
    CommonModule,
    CarouselComponent,
    ButtonModule,
    StructuredListModule,
    IconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatSnackBarModule,
    MatMenuModule,
    MatTooltipModule,
  ],
})
export class JobsComponent implements OnInit {
  @ViewChild('video') video!: ElementRef<HTMLVideoElement>;
  panelOpenState: boolean[] = [];
  toggleButtonGroup: boolean[] = [];
  activeSlideIndex: number[] = [];
  bodyData: EndApproval[] = [];
  jobsData: GetDetailsResponse | undefined;
  serviceJobs: any = [];
  customerName: string | undefined = '';
  modelName: string | undefined;
  companyId: string | undefined;
  locationId: string | undefined;
  orderId: string | undefined;
  authToken: string = '';
  @ViewChild('imageModal') imageModal: any;
  modalImageUrl: string | undefined;
  modalImageAlt: string | undefined;
  smallImagesUrl: string | undefined;
  smallImagesAlt: string | undefined;
  selectedImageIndex: number | null = null;
  selectedJob: any;
  clickedStates: boolean[] = [];
  selectedImageIsImage: boolean = false;
  selectedImageIsVideo: boolean = false;
  selectedMediaIndex: number = 0;
  languageConfiguration: any = langConfig;
  currentLanguage: any;
  isServiceJobs: boolean = false;
  costOfWork: number = 0;
  currencyCode: string = '';
  dealerImageDetails: StyleSettingsDealerImage | undefined;
  siteSettings: StyleSettingsResponse | undefined;
  showApproveAllOrDeclineAllButtons: boolean = true;
  introOutroMediaData!: DealerMediaResponse;
  isWalkthroughEnabled: boolean | undefined = false;
  selectedMedia!: any;

  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    public client: Client,
    private elementRef: ElementRef,
    public appService: AppService,
    private videoPlayerService: VideoPlayerService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  openMediaModal(imageUrl: string | undefined, altText: string | undefined) {
    this.modalImageUrl = imageUrl;
    this.modalImageAlt = altText;
    this.imageModal.nativeElement.style.display = 'block';
    document.querySelector('.backdrop')?.setAttribute('style', 'display:block');
  }

  closeMediaModal(event: Event) {
    event.stopPropagation();
    this.videoPlayerService.clearActivePlayer();
    this.imageModal.nativeElement.style.display = 'none';
    document.querySelector('.backdrop')?.setAttribute('style', 'display:none');
  }

  stopEventPropagation(event: Event) {
    event.stopPropagation();
  }

  ngOnInit(): void {
    this.selectedImageIndex = 0;
    if (isPlatformBrowser(this.platformId)) {
      this.route.queryParams.subscribe((params: any) => {
        const token = params['token'];

      forkJoin({
        detailsResponse: this.client.pageLoadDetails(token),
        siteSettings: this.appService.getStyleSettings(token).pipe(
          catchError(() => {
          return of(null);
        })),
        dealerMedia: this.appService.getDealerMediaResponse(token).pipe(
          catchError((error) => {
            return of({intro: null, outro: null});
          })
        )
      }).subscribe({
        next: (results: { detailsResponse: GetDetailsResponse; siteSettings: StyleSettingsResponse; dealerMedia: DealerMediaResponse }) => {
          this.introOutroMediaData = results.dealerMedia;
          if (results.detailsResponse) {
              this.jobsData = results.detailsResponse
              this.companyId = this.jobsData?.companyId;
              if (this.jobsData?.order) {
                this.locationId = this.jobsData.order.locationId;
                this.orderId = this.jobsData.order.id;
                this.serviceJobs = this.jobsData.order.serviceJobs;
                if (this.serviceJobs.length <= 0) {
                  this.isServiceJobs = true;
                }
                this.totalCostOfWork();
                this.selectedJob = this.serviceJobs[0];
                this.clickedStates = new Array(this.serviceJobs.length).fill(
                  false
                );
                this.clickedStates[0] = true;
                this.customerName = this.jobsData?.order?.customer?.name;
                this.modelName =
                  this.jobsData?.order?.vehicles?.make +
                  ' ' +
                  this.jobsData?.order?.vehicles?.model;
                this.approveAllOrDeclineAllButtonsStatus();
              }
              if (this.selectedJob?.checkpoints?.[0]?.findings?.[0]?.media) {
                const firstImageOrVideo =
                  this.selectedJob.checkpoints[0].findings[0].media.find(
                    (item: { mimeType: string | string[] }) =>
                      item.mimeType.includes('Image') ||
                      item.mimeType.includes('Video')
                  );

                if (firstImageOrVideo) {
                  this.showLargeImage(0, firstImageOrVideo);
                }
              }
              if (this.selectedJob?.checkpoints?.[0]?.media) {
                const firstImageOrVideo =
                  this.selectedJob.checkpoints[0].media.find(
                    (item: { mimeType: string | string[] }) =>
                      item.mimeType.includes('Image') ||
                      item.mimeType.includes('Video')
                  );

                if (firstImageOrVideo) {
                  this.showLargeImage(0, firstImageOrVideo);
                }
              }
              if (this.jobsData?.token !== undefined) {
                this.authToken = this.jobsData.token;
              }
              sessionStorage.setItem('token', this.authToken);
              this.panelOpenState.length = this.toggleButtonGroup.length =
                this.serviceJobs.length;
              this.activeSlideIndex = new Array(this.serviceJobs.length).fill(
                0
              );
              this.toggleButtonGroup = Array(this.serviceJobs.length).fill(
                true
              );
              const localLang = localStorage.getItem('lang');
              const title = results.siteSettings?.titles?.find(
                (title: StyleSettingTitles) => {
                  return (
                    title.page === 'JobConsent' &&
                    title.type === 'Welcome' &&
                    title.content
                  );
                }
              );
              const Content =
                title && title.content
                  ? this.appService.convertToHtml(title.content)
                  : null;
              if (localLang == null) {
                const dialogRef = this.dialog.open(MatDialogComponent, {
                  data: {
                    type: 'LanguageDialog',
                  },
                });

                dialogRef.afterClosed().subscribe((result) => {
                  this.dialog.open(MatDialogComponent, {
                    data: {
                      type: 'landingDialog',
                      customerName: this.customerName,
                      content: Content,
                    },
                  });
                });
              } else {
                this.appService.setDefaultLanguage();
                this.dialog.open(MatDialogComponent, {
                  data: {
                    type: 'landingDialog',
                    customerName: this.customerName,
                    content: Content,
                  },
                });
              }
            }
            if (results.siteSettings) {
              this.siteSettings = results.siteSettings;
              this.dealerImageDetails = results.siteSettings.dealerImage;
            }
          },
        });
      });
    }
  }

  onButtonGroupClick(buttonName: string, jobData: ServiceJob) {
    if (buttonName === 'Accept') {
      this.consentDetailsCall(buttonName, jobData);
    } else {
      const dialogRef = this.dialog.open(MatDialogComponent, {
        data: {
          type: buttonName,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.consentDetailsCall(buttonName, jobData);
        }
      });
    }
  }

  consentDetailsCall(buttonName: string, jobData: ServiceJob) {
    const matchedServicJob: ServiceJob = this.serviceJobs.find(
      (item: ServiceJob) => item.id === jobData.id
    );
    const arrayOfMatchedData = [matchedServicJob];

    this.bodyData = arrayOfMatchedData.map(
      (x) =>
        <EndApproval>{
          id: x.id,
          description: x.description,
          descriptionLong: x.descritpionLong,
          price: x.price,
          approvalStatus: buttonName,
          billToClientName: x.billToCustomerName,
        }
    );
    const locationId = this.locationId?.replace(/[{ }]/g, '');
    
    this.client
      .consentDetails(
        this.authToken,
        this.companyId,
        this.orderId,
        locationId,
        this.bodyData
      )
      .subscribe((response: any) => {
        for (const serviceJob of this.serviceJobs) {
          if (serviceJob.id === jobData.id) {
            serviceJob.approvalStatus = buttonName;
          }
        }

        if (response.status === 200 && buttonName) {
          this.dialog.open(MatDialogComponent, {
            data: {
              type: 'Accept',
            },
          });
        }
        this.totalCostOfWork();
        this.approveAllOrDeclineAllButtonsStatus();
      });
  }

  togglePanel(id: number) {
    this.panelOpenState[id] = !this.panelOpenState[id];
  }

  @ViewChild('carousel1') myCarousel!: ElementRef;
  isEventInProgress: boolean = false;

  onCarouselSwipe(direction: 'left' | 'right', i: number) {
    if (this.isEventInProgress) {
      return;
    }
    this.isEventInProgress = true;
    setTimeout(() => {
      this.isEventInProgress = false;
      const items = this.elementRef.nativeElement.querySelectorAll(
        '.carousel-track-items' + i
      );
      const indicators = this.elementRef.nativeElement.querySelectorAll(
        '.indicators' + i
      );
      const itemCount = items.length;

      if (direction === 'right') {
        this.activeSlideIndex[i] = this.activeSlideIndex[i] - 1;

        if (0 > this.activeSlideIndex[i]) {
          this.activeSlideIndex[i] = itemCount - 1;
        }
      } else if (direction === 'left') {
        this.activeSlideIndex[i] = this.activeSlideIndex[i] + 1;
        if (this.activeSlideIndex[i] >= itemCount) {
          this.activeSlideIndex[i] = 0;
        }
      }

      this.updateActiveSlideClass(
        items,
        indicators,
        this.activeSlideIndex[i],
        direction
      );
    }, 600);
  }

  private updateActiveSlideClass(
    items: NodeListOf<HTMLElement>,
    indicators: NodeListOf<HTMLElement>,
    activeIndex: number,
    direction: 'left' | 'right'
  ) {
    items.forEach((item, index) => {
      if (direction === 'right') {
        item.classList.remove('image-slide');
        item.classList.add('reverse');
      } else {
        item.classList.remove('reverse');
        item.classList.add('image-slide');
      }
      if (index === activeIndex) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
    indicators.forEach((indicator, index) => {
      if (index === activeIndex) {
        indicator.classList.add('active');
      } else {
        indicator.classList.remove('active');
      }
    });
  }
  showDetails(job: any) {
    this.selectedJob = job;
  }
  onSelectedTile(jobData: any, index: number) {
    this.selectedJob = jobData;
    this.clickedStates = new Array(this.serviceJobs.length).fill(false);
    this.clickedStates[index] = true;
    if (this.selectedJob?.checkpoints?.[0]?.findings?.[0]?.media) {
      const firstImageOrVideo =
        this.selectedJob.checkpoints[0].findings[0].media.find(
          (item: { mimeType: string | string[] }) =>
            item.mimeType.includes('Image') || item.mimeType.includes('Video')
        );

      if (firstImageOrVideo) {
        this.showLargeImage(0, firstImageOrVideo);
      }
    } else if (this.selectedJob?.checkpoints?.[0]?.media) {
      const firstImageOrVideo = this.selectedJob.checkpoints[0].media.find(
        (item: { mimeType: string | string[] }) =>
          item.mimeType.includes('Image') || item.mimeType.includes('Video')
      );

      if (firstImageOrVideo) {
        this.showLargeImage(0, firstImageOrVideo);
      }
    } else {
      return;
    }
  }
  showLargeImage(index: number, item: any) {
    this.selectedMedia = item;
    this.selectedImageIndex = index;
    this.selectedMediaIndex = index;

    if (item.mimeType.includes('Image')) {
      this.selectedImageIsImage = true;
      this.selectedImageIsVideo = false;
      this.smallImagesUrl = item.url;
      this.smallImagesAlt = item.altText;
    } else if (item.mimeType.includes('Video')) {
      this.selectedImageIsImage = false;
      this.selectedImageIsVideo = true;
      this.smallImagesUrl = item.url;
      this.smallImagesAlt = item.altText;
      if (this.video) {
        this.video.nativeElement.load();
      }
      if (this.video) {
        this.video.nativeElement.load();
      }
    }
  }

  onMediaItemClicked(index: number, item: any) {
    this.selectedMedia = null;
    setTimeout(() => {
      this.showLargeImage(index, item);
    }, 10);
    this.selectedMediaIndex = index;
  }

  hasManyMediaItems(): boolean {
    const maxMediaItems = 6; // Set your desired maximum number of media items
    return (
      this.selectedJob.checkpoints[0]?.findings[0]?.media?.length >
      maxMediaItems
    );
  }

  hasMediaItems(): boolean {
    if (this.selectedJob?.checkpoints) {
      return (
        this.selectedJob.checkpoints[0]?.findings[0]?.media?.length > 0 ||
        this.selectedJob.checkpoints[0]?.media?.length > 0
      );
    } else {
      return this.selectedJob.checkpoints;
    }
  }

  totalCostOfWork() {
    this.costOfWork = 0;
    this.currencyCode = this.serviceJobs[0].price.currency;
    this.serviceJobs.forEach((jobs: ServiceJob) => {
      if (
        jobs &&
        jobs.price &&
        jobs.price.grossPrice &&
        jobs.price.grossPrice != undefined &&
        jobs.approvalStatus !== 'Reject'
      ) {
        this.costOfWork += jobs.price.grossPrice;
      }
    });
  }

  approveAllOrDeclineAllButtonsStatus() {
    this.showApproveAllOrDeclineAllButtons = true;
    const arrayOfMatchedData: ServiceJob[] = this.serviceJobs.filter(
      (item: ServiceJob) => {
        return (
          item.approvalStatus !== 'Accept' &&
          item.approvalStatus !== 'Reject' &&
          !this.isObjectEmpty(item.total)
        );
      }
    );

    if (arrayOfMatchedData.length <= 1) {
      this.showApproveAllOrDeclineAllButtons = false;
    }
  }

  onApproveAllOrDeclineAllClick(buttonName: string) {
    const arrayOfMatchedData: ServiceJob[] = this.serviceJobs.filter(
      (item: ServiceJob) => {
        return (
          item.approvalStatus !== 'Accept' &&
          item.approvalStatus !== 'Reject' &&
          !this.isObjectEmpty(item.total)
        );
      }
    );
    const dialogRef = this.dialog.open(MatDialogComponent, {
      data: {
        type: buttonName + 'AllDisclaimer',
        jobs:
          arrayOfMatchedData.length == this.serviceJobs.length
            ? 'all'
            : arrayOfMatchedData.length,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.approveOrDeclineAll(buttonName);
      }
    });
  }

  approveOrDeclineAll(buttonName: string) {
    const arrayOfMatchedData: ServiceJob[] = this.serviceJobs.filter(
      (item: ServiceJob) => {
        return (
          item.approvalStatus !== 'Accept' &&
          item.approvalStatus !== 'Reject' &&
          !this.isObjectEmpty(item.total)
        );
      }
    );
    this.bodyData = arrayOfMatchedData.map(
      (serviceJob: ServiceJob) =>
        <EndApproval>{
          id: serviceJob.id,
          description: serviceJob.description,
          descriptionLong: serviceJob.descritpionLong,
          price: serviceJob.price,
          approvalStatus: buttonName,
          billToClientName: serviceJob.billToCustomerName,
        }
    );
    const locationId = this.locationId?.replace(/[{ }]/g, '');

    this.client
      .consentDetails(
        this.authToken,
        this.companyId,
        this.orderId,
        locationId,
        this.bodyData
      )
      .subscribe((response: any) => {
        arrayOfMatchedData.forEach((element) => {
          element.approvalStatus = buttonName;
        });

        if (response.status === 200 && buttonName === 'Accept') {
          this.dialog.open(MatDialogComponent, {
            data: {
              type: 'AcceptAll',
              jobs:
                arrayOfMatchedData.length == this.serviceJobs.length
                  ? 'all'
                  : arrayOfMatchedData.length,
            },
          });
        }
        this.approveAllOrDeclineAllButtonsStatus();
        this.totalCostOfWork();
      });
  }

  costOfWorkInfo() {
    const title = this.siteSettings?.titles?.find(
      (title: StyleSettingTitles) => {
        return (
          title.page === 'JobConsent' &&
          title.type === 'CostOfWork' &&
          title.content
        );
      }
    );
    const costOfWorkContent =
      title && title.content
        ? this.appService.convertToHtml(title.content)
        : null;
    this.dialog.open(MatDialogComponent, {
      data: {
        type: 'costOfWorkInfo',
        content: costOfWorkContent,
      },
    });
  }

  isObjectEmpty(obj: any): boolean {
    return Object.keys(obj).length === 0;
  }

  checkRadioButtonColor(checkpoint: Checkpoint, color: string) {
    if (this.isObjectEmpty(checkpoint.findings)) {
      return color === 'yellow' ? true : false;
    } else {
      const hasMatchingElement = checkpoint.findingTypeOptions?.some(
        (element: FindingTypeOption) => {
          return (
            element.id === checkpoint.findings?.[0]?.findingType?.id &&
            element.color?.toLocaleLowerCase() === color
          );
        }
      );

      if (hasMatchingElement) {
        return true;
      }
    }
    return false;
  }
}
